import { render, staticRenderFns } from "./FormSelector.vue?vue&type=template&id=308ca7a6&scoped=true"
import script from "./FormSelector.vue?vue&type=script&lang=js"
export * from "./FormSelector.vue?vue&type=script&lang=js"
import style0 from "./FormSelector.vue?vue&type=style&index=0&id=308ca7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ca7a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
